module.exports = __webpack_public_path__ + "static/media/kishoriB3.514480c5.png";